// extracted by mini-css-extract-plugin
module.exports = {"headlineDivider":"Headline_headlineDivider__vJ8_m"};